import React from 'react'
import getYouTubeId from 'get-youtube-id'
import YouTube from 'react-youtube'
import PortableText from '@sanity/block-content-to-react'
import styled from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
  @media (max-width: 650px) {
    display: none;
  }
`;
const serializers = {
    types: {
      youtube: ({node}) => {
        const { url } = node
        const id = getYouTubeId(url)
        return (<YouTube videoId={id}/>)
      }
    }
}

export default function YoutubeBlock ({blocks}) {
  return (
    <Wrapper>
    <PortableText blocks={blocks} serializers={serializers} style={{ width :"100px"}}/>
    </Wrapper>
  )
}